import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

type Props = {
    children: ReactNode;
    className?: string;
};

export const NoResults = ({ children, className = '' }: Props) => {
    return (
        <section
            className={cn(
                'ml-0 flex min-h-[158px] w-full flex-col items-center justify-center border border-border-info p-md text-center',
                className
            )}
        >
            <BodySecondary color="secondary">{children}</BodySecondary>
        </section>
    );
};
